import React, { useEffect, useState } from 'react';
import { Content } from './styles';

interface LongTextProps {
  fullText: string;
}

const LongText = (props: LongTextProps) => {
  const { fullText } = props;

  const CHAR_LIMIT = 140;

  const [text, setText] = useState<string>(
    fullText.length > CHAR_LIMIT ? `${fullText.slice(0, CHAR_LIMIT)} ...` : fullText,
  );
  const [showCollapseButton] = useState<boolean>(fullText.length > CHAR_LIMIT);
  const [collapseButtonClicked, setCollapseButtonClicked] = useState<boolean>(false);

  useEffect(() => {
    if (collapseButtonClicked) setText(fullText);
    if (!collapseButtonClicked)
      setText(fullText.length > CHAR_LIMIT ? `${fullText.slice(0, CHAR_LIMIT)} ...` : fullText);
  }, [collapseButtonClicked]);

  return (
    <Content>
      {text}
      {showCollapseButton && (
        <button
          type="button"
          className="btn btn-outline-primary ml-1 btn-long-text p-0"
          onClick={() => setCollapseButtonClicked(!collapseButtonClicked)}
        >
          {collapseButtonClicked ? '-' : '+'}
        </button>
      )}
    </Content>
  );
};

export default LongText;
